import dayjs from "dayjs";

type Props = {
  timestring: string;
  hastime?: boolean;
};

function DateTime({ timestring, hastime = true }: Props) {
  let time = "";
  if (timestring !== "") {
    time = dayjs(timestring).format(`DD MMM YYYY ${hastime ? "HH:mm:ss" : ""}`);
  }
  return <span>{time}</span>;
}

export default DateTime;
